// extracted by mini-css-extract-plugin
module.exports = {"label":"Login_label__3mzpg","input":"Login_input__1TRXV","button":"Login_button__1N2yL"};